var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"index-play-button is-hidden-hover",on:{"click":_vm.playPlaylist}},[_c('IconPlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }